var _excluded = ["name", "size", "block", "as"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import InteractiveIcon from "../InteractiveIcon/index.js";

/**
 * Render an interactive icon as a link. Use this component when the interaction will send the user
 * to a different url.
 *
 * Passes ref to underlying link
 */
var IconLink = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var name = _ref.name,
    size = _ref.size,
    block = _ref.block,
    as = _ref.as,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(InteractiveIcon, _extends({
    ref: ref,
    as: as,
    name: name,
    block: block,
    size: size
  }, rest));
});
IconLink.propTypes = {
  /**
   * Icon name
   */
  name: PropTypes.string.isRequired,
  /**
   * Component to render
   */
  as: PropTypes.elementType,
  /**
   * To determine if icon should have a block display
   */
  block: PropTypes.bool,
  /**
   * Size class
   */
  size: PropTypes.oneOf(['sm', 'md', 'lg'])
};
IconLink.defaultProps = {
  size: null,
  as: 'a'
};
IconLink.displayName = 'IconLink';
export default IconLink;